import x from "../../../assets/images/X.png";
import back from "../../../assets/images/back.png";

import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { SetSearch } from "../../../features/TopSearches/TopSearchesSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import {
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  SortProducts,
} from "../../../features/Products/ProductSlice";
import NotificationModal from "../NotificationModal";

function SeacrhMenuDrops({ show, setShow, id, setShowbefore, setShowfirst }) {
  const { i18n, t } = useTranslation();
  const { subtype } = useSelector((store) => store.topsearches);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sq, setsq] = useState("");

  let parametres = new URLSearchParams(useLocation().search);

  return (
    <>
      <Modal show={show} fullscreen className="modal fade mx-0 px-0">
        <Modal.Body className="p-0 m-0 ">
          <div className="modal-header justify-content-between align-items-center d-flex pb-0 px-4">
            <div style={{ cursor: "pointer" }} onClick={() => setShow(false)}>
              <button
                type="button"
                className="close close-txt close-modal align-items-center px-0"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setShow(false)}
              >
                <img
                  alt="main"
                  src={back}
                  onClick={() => setShow(false)}
                  className={` ${
                    i18n.language == "en" ? "Previous" : "PreviousAr"
                  }`}
                />
              </button>
            </div>
            <button
              type="button"
              className="close close-txt close-modal align-items-center px-0"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setShow(false)}
            >
              <img
                alt="main"
                src={x}
                onClick={() => setShow(false)}
                className="x-close  mb-1"
              />
            </button>
          </div>

          <div className="modal-body px-4">
            {subtype == "newArrival" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate("/products?topic=newdrops") &
                      dispatch(SortProducts("Newest")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("New Arrivals")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate("/products?topic=TopPicks") &
                      dispatch(SortProducts("Newest")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Our Crush On")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&id=AqFLulu9y2m4mqEIkch1"
                      ) &
                      dispatch(SortProducts("Newest")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Bags")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&id=WJmwaMSWxtl1dK1sPZ1x"
                      ) &
                      dispatch(SortProducts("Newest")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Shoes")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&id=07kdA6cD3NDKxX8pQ7w1"
                      ) &
                      dispatch(SortProducts("Newest")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Jewelry")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&subcategory=kYTvn5wAxopx5jpqotC0&id=LVw0hUP9kEcd1Qr9CoEk"
                      ) &
                      dispatch(SortProducts("Newest")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Watches")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate("/products?topic=newdrops") &
                      dispatch(SortProducts("Newest")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("view-all")}
                  </div>
                </div>
              </>
            )}
            {subtype == "Women" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&gender=WFA967se7qX0jYtySgTj"
                      ) & dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("Women")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&id=AqFLulu9y2m4mqEIkch1&gender=WFA967se7qX0jYtySgTj"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Bags")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&id=yJDeEt0uKPxfxtqOM42V&gender=WFA967se7qX0jYtySgTj&"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Clothes")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&id=WJmwaMSWxtl1dK1sPZ1x&gender=WFA967se7qX0jYtySgTj&"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Shoes")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj&"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Accessories")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&subcategory=kYTvn5wAxopx5jpqotC0&id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj&"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Watches")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&id=07kdA6cD3NDKxX8pQ7w1&gender=WFA967se7qX0jYtySgTj&"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Jewelry")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&gender=WFA967se7qX0jYtySgTj"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("view-all")}
                  </div>
                </div>
              </>
            )}

            {subtype == "Men" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&gender=KG3s4pPk3arcBux5ERnD"
                      ) & dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("Men")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&id=AqFLulu9y2m4mqEIkch1&gender=KG3s4pPk3arcBux5ERnD"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Bags")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&id=yJDeEt0uKPxfxtqOM42V&gender=KG3s4pPk3arcBux5ERnD&"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Clothes")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&id=WJmwaMSWxtl1dK1sPZ1x&gender=KG3s4pPk3arcBux5ERnD&"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Shoes")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&id=LVw0hUP9kEcd1Qr9CoEk&gender=KG3s4pPk3arcBux5ERnD&"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Accessories")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&subcategory=kYTvn5wAxopx5jpqotC0&id=LVw0hUP9kEcd1Qr9CoEk&gender=KG3s4pPk3arcBux5ERnD&"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Watches")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&id=07kdA6cD3NDKxX8pQ7w1&gender=KG3s4pPk3arcBux5ERnD&"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Jewelry")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&gender=KG3s4pPk3arcBux5ERnD"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("view-all")}
                  </div>
                </div>
              </>
            )}
            {subtype == "Kids" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&gender=uw8UHRzTK2qlgU8Y4cVc"
                      ) & dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("Kids")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&id=yJDeEt0uKPxfxtqOM42V&gender=btauY7skTre33RbhtagD"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Boys clothes")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&id=yJDeEt0uKPxfxtqOM42V&gender=tTwOQNL4etSBiJy0j5zY"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Girls clothes")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&id=yJDeEt0uKPxfxtqOM42V&gender=zw8UHRzTK2qlgU8Y4cVc&"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Baby clothes")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&id=WJmwaMSWxtl1dK1sPZ1x&gender=uw8UHRzTK2qlgU8Y4cVc&"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Shoes")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&id=LVw0hUP9kEcd1Qr9CoEk&gender=uw8UHRzTK2qlgU8Y4cVc&"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Accessories")}
                  </div>
                </div>

                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate(
                        "/products?topic=newdrops&gender=uw8UHRzTK2qlgU8Y4cVc"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("view-all")}
                  </div>
                </div>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SeacrhMenuDrops;
